import {getExampleValue} from '../../../../dynamic/reducers/examples-reducer';
import {getApiUrl,getxDevCenterMetaData} from '../../../../dynamic/reducers/rhs-schema-reducer';
import {getMethodType,getSummaryDetails,getEnabledDownload,getCustomHeadersSelectedValue,getOverRideMerchantCredentials} from '../../../../../lhs/reducers/lhs-reducer';
import {getCurrentAuthType,getAllConfigurationData,getPartnerName, getCurrentJWTMerchantKey} from '../../../../../lhs/reducers/configuration-reducer';
import {putDataInDevCenterDataStore,getDevCenterDataStore} from '../../../../../app/store';
import {getHttpSignature,getJWTToken} from "../../../../../libs/cybs-request-header";
import {getCredCookie,isDefaultHTTPMerchantId,isDefaultJWTMerchantId,getMerchantDetails,setHTTPCredsInCookies,setJWTCredsInCookies,setDefaultHTTPCredsInCookies,setDefaultJWTCredsInCookies} from "../../../../../commons/cookie";
import {isJson} from "../../../../../libs/common-library";

function enableResponseSection()
{
  var responseEditor = document.getElementById("ResponseSection");
    if(responseEditor != undefined)
    {
      responseEditor.style.display = 'flex';
    }
}
// function to send request
function SendRequest(enabledDownload)
{
    putDataInDevCenterDataStore({type:'UPDATE_IS_RESPONSE_ACTIVATED',isResponseActivated:true});
    putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_PROGRESS_FLAG',responseProgressFlag:true});
    var responseElement = document.getElementById('Response Field Description');
    if(responseElement){
      responseElement.scrollIntoView();
    }  
    getExampleValue();
    enableResponseSection();
    var jsonRequest = getExampleValue();
    var methodType = getMethodType().toUpperCase();
    var metaData = getxDevCenterMetaData();
    var element = document.getElementById("requestUrl").innerText.trim();
    var requestUrl = element.replace(/[\s]*[/][\s]*/g, '/').replace(/[\s]*[?][\s]*/g, '?').replace(/[\s]*[&][\s]*/g, '&');
    if(requestUrl.slice(-1) == "&")
    {
      requestUrl = requestUrl.substring(0,requestUrl.length-1);
    }
    var requestHeaders = {};
    
    var param = [],
    rxp = /{([^}]+)}/g,
    url = requestUrl,
    curMatch;

    while (curMatch = rxp.exec(url)) {
    param.push(curMatch[1]);
    }

    if (param != null) {
      for (var i = 0; i < param.length; i++) {

        if (param[i] == "") {
          break;
        } else {
          requestUrl = requestUrl.replace(new RegExp("{" + param[i] + "}"), param[i]);
        }
      }
    }
    requestUrl = encodeURI(requestUrl);
    if(methodType.toLowerCase() != 'get' && methodType.toLowerCase() != 'delete')
    {
      if(getExampleValue() == undefined)
      {
        jsonRequest = "{}";
      }
    }
    var allConfigurationData = getAllConfigurationData();
    var defaultProcessor = allConfigurationData['defaultProcessor'];
    var overridenCredential = getOverRideMerchantCredentials();
    if(getCurrentAuthType() == "HTTP Signature")
    {
      if(overridenCredential!= null && isDefaultHTTPMerchantId() && allConfigurationData['processors'][defaultProcessor]['additionalCredentials'][overridenCredential] != undefined)
      {
        var overridenMerchantDetails = allConfigurationData['processors'][defaultProcessor]['additionalCredentials'][overridenCredential];
        requestHeaders = getHttpSignature(requestUrl,methodType,jsonRequest,overridenMerchantDetails["merchantId"],overridenMerchantDetails['authentication']['httpSignature']["keyId"],overridenMerchantDetails['authentication']['httpSignature']["secretKey"]); 
      }
      else{
        requestHeaders = getHttpSignature(requestUrl,methodType,jsonRequest,getCredCookie("merchantId"),getCredCookie("key"),getCredCookie("secretKey")); 
      }
    }
    else if (getCurrentAuthType() == "Json Web Token")
    {
      if(overridenCredential!= null && isDefaultJWTMerchantId() && allConfigurationData['processors'][defaultProcessor]['additionalCredentials'][overridenCredential] != undefined)
      {
        var overridenMerchantDetails = allConfigurationData['processors'][defaultProcessor]['additionalCredentials'][overridenCredential];
        requestHeaders = getJWTToken(getApiUrl(),getMethodType(),jsonRequest,overridenMerchantDetails["merchantId"],overridenMerchantDetails['authentication']['jwt']['p12Key']);
      }
      else{
        requestHeaders = getJWTToken(getApiUrl(),getMethodType(),jsonRequest,getCredCookie("jwtMerchantId"),sessionStorage.getItem('jwttoken'), getCurrentJWTMerchantKey());
      }
    }

    if(getCustomHeadersSelectedValue() != null)
    {
      for (var key in getCustomHeadersSelectedValue())
      {
        requestHeaders[key] = getCustomHeadersSelectedValue()[key];
      }
    }

    putDataInDevCenterDataStore({type:'UPDATE_REQUEST_HEADERS',requestHeaders:requestHeaders});
     // Setting the Content Type based on Headers
    // Do not set content type if the request has no body (get/delete verbs)
    if(methodType.toLowerCase() != 'get' && methodType.toLowerCase() != 'delete'){
      setContentType(requestHeaders, metaData? metaData['contentType'] : undefined);
    }

    
    var g_xc;
    g_xc = new XHConn(enabledDownload,methodType,requestUrl,fnWhenDone());
    g_xc.connect(jsonRequest, requestHeaders);
    
}

 function fnWhenDone(xmlhttp,download)
    {
      if(xmlhttp != undefined)
      { 
        var txt = xmlhttp.responseText;
        txt = txt.replace(/></g, "> <").replace(/&amp;/, "&");
        putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_CODE',responseCode:xmlhttp.status});
        // if its a json string beautify it .
        if(isJson(txt))
        {
          putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_CONTENT',responseContent:JSON.stringify(JSON.parse(txt),null,2)});
        }
        // else ignore and move on
        else
        {
          putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_CONTENT',responseContent:txt});
        }
        
        var thisResponseHeaders = getHeadersAsObject(xmlhttp);
        putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_HEADERS', responseHeaders:thisResponseHeaders});
        putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_PROGRESS_FLAG',responseProgressFlag:false});
        if(getEnabledDownload()&&download)
        {      
          var acceptType = thisResponseHeaders['content-type'];
          if(acceptType != undefined)
          {
            downloadFile(acceptType,txt,getSummaryDetails()); 
          }        
        }
      }
    }

function setContentType(httpTokenHeader, contentType) {
  if (contentType != undefined) {
    if (contentType != "" && contentType != null)
      httpTokenHeader['Content-Type'] = contentType;
  } else {
    httpTokenHeader['Content-Type'] = "application/json";
  }
}

function getTextFromRequestEditor()
{
  var requestEditorContent = document.getElementsByClassName(" CodeMirror-line ");
    var textItem = "";
    for(var i =0;i <requestEditorContent.length;i++)
    {
      var lineItem = requestEditorContent[i].textContent;
      if(requestEditorContent[i].textContent.trim().length>0)
      {
        if(requestEditorContent[i].textContent.trim().length == 1 && (requestEditorContent[i].textContent.trim()== "{" || requestEditorContent[i].textContent.trim()== "}" || requestEditorContent[i].textContent.trim()=="]"))
        {
          textItem = textItem + requestEditorContent[i].textContent.trim();
          if(requestEditorContent[i].textContent.length == 1 && requestEditorContent[i].textContent == "}"){
            break;
          }
        }
        else if(requestEditorContent[i].textContent.trim().length >1)
        {
          textItem = textItem + requestEditorContent[i].textContent.trim();
        }
        
      }
    }
    textItem = textItem.replace(/\\n/g, "\\n")  
               .replace(/\\'/g, "\\'")
               .replace(/\\"/g, '\\"')
               .replace(/\\&/g, "\\&")
               .replace(/\\r/g, "\\r")
               .replace(/\\t/g, "\\t")
               .replace(/\\b/g, "\\b")
               .replace(/\\f/g, "\\f");
// remove non-printable and other non-valid JSON chars
    textItem = textItem.replace(/[\u0000-\u0019]+/g,""); 
    return textItem;
}
//Send and reset functionalities

function XHConn(download,requestMethod,requestUrl) {
    var xmlhttp, bComplete = false;

    try {
      xmlhttp = new XMLHttpRequest();
    } catch (e) {
      xmlhttp = false;
    }
    if (!xmlhttp) return null;

    this.connect = function (sPostData, headers,fnDone) {
      try {

        bComplete = false;
        xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState == 4 && !bComplete) {
            bComplete = true;
            fnWhenDone(xmlhttp,download);
          }
        };
                
        xmlhttp.open(requestMethod, requestUrl, true);
        xmlhttp.timeout = 120000; //2 mins timeout
        // xmlhttp.setRequestHeader("content-type", "application/json");
                
        if(headers){
          // This block of code is to disable authentication for tokenize card
         //headers = removeHeadersForNoAuth(headers,"/v1/tokens");
          for(var header in  headers){
            if(header != 'host' && header != 'date')  
              xmlhttp.setRequestHeader(header, headers[header]);
          }
        }
        xmlhttp.send(sPostData);
      } catch (z) {
        return false;
      }
      return true;
    };
    return this;
  }


function getHeadersAsObject(xhr) {
    var headers = {};
    xhr.getAllResponseHeaders()
      .split('\u000d\u000a')
      .forEach(function(line) {
        if (line.length > 0) {
          var delimiter = '\u003a\u0020',
            header = line.split(delimiter);
          headers[header.shift().toLowerCase()] = header.join(delimiter);
        }
      })
    return headers;
  }

  function downloadFile(acceptType, response, apiName)
  {
    var a = document.createElement('a');    
    var downloadAttribute;
    var fileName = apiName + '_' + (new Date()).getTime();
    if(acceptType.indexOf('json') > -1 && isJson(response))
    {
      fileName += '.json';
      downloadAttribute = 'data:text/json;charset=utf-8,' + response;
    }
    else if(acceptType.indexOf('xml') > -1)
    {
      fileName += '.xml';
      downloadAttribute = 'data:text/xml;charset=utf-8,' + response;
    }
    else if(acceptType.indexOf('/csv') > -1)
    {
      fileName += '.csv';
      downloadAttribute = 'data:text/csv;charset=utf-8,' + response;
    }
    else if(acceptType.indexOf('/pdf') > -1)
    {
      fileName += '.pdf';
      downloadAttribute = 'data:application/pdf,' + response;
    }
    else if(acceptType.indexOf('text/') > -1)
    {
      // handle all other file types with text content
      fileName += '.txt';
      downloadAttribute = 'data:text/plain;charset=utf-8,' + response;
    }
    // else if(acceptType.indexOf('application/') > -1)
    // {
    //   // handle all other file types with binary content
    //   fileName += '.file';
    //   downloadAttribute = 'data:application/octet-stream,' + response;
    // }
    else
    {
      // do not download if reponse doesn't match the above criteria
      return;
    }
    a.download = fileName;
    a.setAttribute('href', downloadAttribute);
    a.click();
  }
  export default {SendRequest};
  export {SendRequest,getHeadersAsObject,getTextFromRequestEditor,enableResponseSection}; 
